import { INVENTORY_MODULE } from "@/api_framework/api_config";
import {
  IPOExtractInvoiceDetailsResponse,
  IPOExtractInvoiceDetailsResponseData,
} from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { setExtractInvoiceDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = {
  status: boolean;
  message: string;
  data?: IPOExtractInvoiceDetailsResponseData | null;
};

export const useExtractInvoiceDetailsAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (file: File, poId?: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const formData = new FormData();
        formData.append("file", file);
        if (poId) {
          formData.append("po_id", poId);
        }
        const response: InventoryTaxCreateAPIResponse = await axios
          .post(INVENTORY_MODULE?.EXTRACT_INVOICE_DETAILS?.baseURL ?? "", formData, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res: AxiosResponse<IPOExtractInvoiceDetailsResponse>) => {
            if (res.data.status === true) {
              dispatch(setExtractInvoiceDetails({ data: res.data.data }));
              // The server explains scan caveats (unknown vendor, etc.) here — pass it to the caller.
              return { status: true, message: res.data.message, data: res.data.data };
            } else {
              dispatch(setExtractInvoiceDetails({ data: null }));
              return { status: false, message: res.data.message, data: null };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            captureError(e);
            dispatch(setExtractInvoiceDetails({ data: null }));
            return { status: false, message: e.message, data: null };
          });
        return response;
      } catch (e: any) {
        dispatch(setExtractInvoiceDetails({ data: null }));
        return { status: false, message: e.message, data: null };
      }
    },
    [dispatch],
  );
  return { execute };
};
